import { Form, Input, InputNumber, Select, Switch } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';

//布局
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export default function BranchStoreMenuWarehouseSpecSpecialEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /** 门店菜式规格数据 */
    const [branchStoreMenuWarehouseSpecData, setBranchStoreMenuWarehouseSpecData] = useState<any>();

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    /** 后端数据wmService */
    let wmService: any = "";

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
        const fetchData = async () => {

            form.setFieldsValue({ branchStoreMenuWarehouseSpecId: data.sendPageData.branchStoreMenuWarehouseSpecId });

            fetchApi.GET(wmService, {
                apiId: 'branchStoreMenuWarehouseSpec',
                apiExtend: 'showList',
                apiVariable: data.sendPageData.branchStoreMenuWarehouseSpecId,
            }).then(res => {
                if (res.success) {
                    // console.log(res.data);                    
                    setBranchStoreMenuWarehouseSpecData(res.data);
                }
            });
        }
        fetchData()
    }, [])

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'branchStoreMenuWarehouseSpecSpecial',
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + (data.sendPageData.foodType === 'setMeal' ? '套餐菜式' : '门店菜式规格特殊属性')}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    {...layout}
                    form={form}
                    initialValues={{ "price": 0, "sortBy": 999 }}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Form.Item
                        label="id"
                        name="id">
                        <Input disabled={true} />
                    </Form.Item>

                    <Form.Item
                        label={data.sendPageData.foodType === 'setMeal' ? '套餐菜式类别' : "门店菜式规格"}
                        name="branchStoreMenuWarehouseSpecId">
                        <Select
                            disabled
                            showSearch
                            placeholder={data.sendPageData.foodType === 'setMeal' ? '套餐菜式类别' : "门店菜式规格"}
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(branchStoreMenuWarehouseSpecData, 'branchStoreMenuWarehouseSpecName')}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={data.sendPageData.foodType === 'setMeal' ? '套餐菜式' : "特殊属性"}
                        name="branchStoreMenuWarehouseSpecSpecialName"
                        rules={[{ required: true, message: data.sendPageData.foodType === 'setMeal' ? '请输入套餐菜式' : '请输入特殊属性!' }]}>
                        <Input disabled={sessionStorage.getItem('isAdmin') === 'true' ? false : data.sendPageData.foodType === 'setMeal' ? false : data.type === 'NEW' ? false : true} />
                    </Form.Item>

                    <Form.Item
                        label={data.sendPageData.foodType === 'setMeal' ? '价格' : "加价"}
                        name="price"
                        rules={[{ required: true, message: data.sendPageData.foodType === 'setMeal' ? '请输入价格' : '请输入加价金额!' }]}>
                        <InputNumber min={0} />
                    </Form.Item>

                    <Form.Item
                        label="排序"
                        name="sortBy">
                        <InputNumber min={1} />
                    </Form.Item>

                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        <Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>

                </Form>
            </AntDraggableModal>
        </>
    )
}